'use client';

import * as m from 'motion/react-m';
import { FormattedMessage } from 'react-intl';
import { FloatingKeyword } from './floatingKeyword';
import type { Keyword } from './types';

interface UnderstandingPhaseProps {
  keywords: Keyword[];
}

export function UnderstandingPhase({ keywords }: UnderstandingPhaseProps) {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }} // Smoother phase transition
      className="relative size-full"
    >
      {/* Floating keywords - flat, minimal design */}
      {keywords.map((keyword, index) => (
        <FloatingKeyword key={keyword.id} keyword={keyword} index={index} />
      ))}

      {/* Fallback if no keywords */}
      {keywords.length === 0 && (
        <div className="flex size-full items-center justify-center">
          <m.div
            animate={{
              opacity: [0.4, 0.6, 0.4],
            }}
            transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
            className="text-sm text-text-tertiary"
          >
            <FormattedMessage
              defaultMessage="Analyzing your request…"
              id="qzm3UzZCnf"
              description="Fallback status while the template builder loader has no keywords to show"
            />
          </m.div>
        </div>
      )}
    </m.div>
  );
}
